module.exports = __webpack_public_path__ + "img/chinesecompany62.655f9c16.png";